export function handleFieldsetBlur(_ref) {
  var event = _ref.event,
    onBlur = _ref.onBlur;
  var nextFocusedEl = event.relatedTarget;
  var fieldSet = event.currentTarget;
  var focusStillInFieldset = fieldSet && nextFocusedEl instanceof Element && nextFocusedEl.closest('fieldset') === fieldSet;
  if (!focusStillInFieldset) {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur();
  }
}